module.exports = __webpack_public_path__ + "static/img/holiday.2129f9e8.svg";